// ABOUTME: Legacy market home page with grayscale styling and demo instructions
// ABOUTME: Non-blocking, shows content without authentication requirement
import { ShoppingCart, Key, LogIn } from "lucide-react";
import { useMsal } from "@azure/msal-react";
import { legacyLoginRequest } from "../authConfig.legacy";

export function LegacyHome() {
  const { instance } = useMsal();

  const handleLogin = () => {
    instance.loginPopup(legacyLoginRequest).catch((e) => {
      console.error(e);
    });
  };

  return (
    <div className="flex flex-col items-center max-w-4xl mx-auto">
      {/* Legacy Market Welcome */}
      <div className="text-center mb-12">
        <div className="flex justify-center mb-6">
          <ShoppingCart className="w-20 h-20 text-gray-400" />
        </div>
        <h1 className="text-4xl md:text-6xl font-bold mb-4 text-gray-300 font-mono tracking-tight">
          LEGACY MARKET
        </h1>
        <p className="text-gray-400 text-lg md:text-xl font-mono tracking-widest">
          AZURE AD B2C AUTHENTICATION
        </p>
      </div>

      {/* Demo Instructions */}
      <div className="w-full bg-black/70 backdrop-blur-sm p-8 rounded-lg border-2 border-gray-500 shadow-[0_0_15px_rgba(100,100,100,0.3)] mb-8">
        <div className="flex items-center mb-6">
          <Key className="w-8 h-8 text-gray-400 mr-4" />
          <h2 className="text-2xl font-bold text-gray-300 font-mono">
            STEP 1: LEGACY SYSTEM LOGIN
          </h2>
        </div>

        <div className="space-y-4 mb-6">
          <p className="text-gray-400 font-mono text-sm">
            This is the old system using Azure AD B2C authentication. Sign in here first to establish your account.
          </p>

          <div className="bg-gray-900/50 p-4 rounded border border-gray-600">
            <h3 className="text-gray-300 font-mono font-bold mb-2">📝 DEMO INSTRUCTIONS:</h3>
            <ol className="space-y-2 text-gray-400 text-sm font-mono list-decimal list-inside">
              <li>Sign in with your Azure AD B2C credentials</li>
              <li>Remember your username and password</li>
              <li>After successful login, proceed to Premium Market</li>
              <li>Use the SAME credentials in Premium Market for seamless migration</li>
            </ol>
          </div>

          <div className="bg-gray-900/50 p-4 rounded border border-gray-600">
            <h3 className="text-gray-300 font-mono font-bold mb-2">🔑 WHAT HAPPENS NEXT:</h3>
            <p className="text-gray-400 text-sm font-mono">
              When you sign in to the Premium Market with your password, it will be validated against this Azure AD B2C system
              and automatically migrated to Entra External ID. This is just-in-time password migration in action!
            </p>
          </div>
        </div>

        {/* Sign In Button */}
        <button
          onClick={handleLogin}
          className="w-full bg-gradient-to-r from-gray-600 to-gray-700 hover:from-gray-500 hover:to-gray-600 text-white font-bold font-mono py-4 px-6 rounded-lg transition-all duration-300 flex items-center justify-center"
        >
          <LogIn className="w-5 h-5 mr-2" />
          SIGN IN TO LEGACY MARKET
        </button>
      </div>

      {/* Visual Indicator */}
      <div className="w-full bg-gray-900/50 p-6 rounded-lg border border-gray-600">
        <div className="flex items-center justify-center">
          <div className="text-center">
            <p className="text-gray-500 font-mono text-xs mb-2">OLD SYSTEM VISUAL INDICATOR</p>
            <p className="text-gray-400 font-mono text-sm">
              Notice the black & white interface - this represents the legacy system
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
